import { VIDEO } from '@ezugi/constants';

import { NANOCOSMOS_VIDEO_PLAYER_ID } from '../../store/constants/video';

export const VIDEO_CONTAINER_ID = NANOCOSMOS_VIDEO_PLAYER_ID;

export const BASE_EVENTS = [
  VIDEO.ON_LOADING,
  VIDEO.ON_PLAY,
  VIDEO.ON_READY,
  VIDEO.ON_PAUSE,
  VIDEO.ON_MUTE,
  VIDEO.ON_UNMUTE,
  VIDEO.ON_VOLUME_CHANGE,
  VIDEO.ON_WARNING,
  VIDEO.ON_STREAM_INFO_UPDATE,
  VIDEO.ON_STREAM_INFO,
  VIDEO.ON_STOP_BUFFERING,
  VIDEO.ON_START_BUFFERING,
  VIDEO.ON_STATS,
  VIDEO.ON_ERROR,
];
